import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import classnames from 'classnames';
import Checkmark from 'components/svg/Checkmark';
import { withClickTracking } from 'components/core/library/tracking-utils';

import './checkbox.scss';

export function Checkbox({
	id, name, label, input = { onChange: noop }, disabled = false, handleClick
}) {
	const onCheckboxClick = (e) => {
		handleClick(e);
		input.onChange(!input.value);
	};

	return (
		<div className="ph-checkbox">
			<label className="checkbox-label" htmlFor={id}>
				<span className={classnames('checkbox', { checked: !!input.value })}>
					{!!input.value && <Checkmark />}
				</span>
				<input
					type="checkbox"
					id={id}
					name={name}
					value={input.value}
					onChange={onCheckboxClick}
					disabled={disabled}
				/>
				{label}
			</label>
		</div>
	);
}

Checkbox.propTypes = {
	id: PropTypes.string.isRequired,
	name: PropTypes.string,
	label: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.node
	]),
	input: PropTypes.shape({ value: PropTypes.any, onChange: PropTypes.func }),
	disabled: PropTypes.bool,
	handleClick: PropTypes.func
};

// TODO: Refactor withClickTracking/destructure props without HOC
export default withClickTracking(Checkbox);
